var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5658 6.19889L9.12124 0.0835114C9.00989 -0.0278371 8.78802 -0.0278371 8.67667 0.0835114L0.23216 6.19889C0.00988029 6.42117 -0.10105 6.64387 0.121229 6.86615C0.23216 7.08843 0.565786 7.08843 0.787647 6.97708L8.89896 0.973044L17.0098 6.97708C17.1212 7.08843 17.2321 7.08843 17.3435 7.08843C17.4544 7.08843 17.5658 6.97708 17.6767 6.86615C17.899 6.64387 17.788 6.42117 17.5658 6.19889Z",
    fill: "#36505E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3603 7.08789C15.1376 7.08789 14.9149 7.31059 14.9149 7.53287V14.8773H11.2388V10.8712C11.2388 9.64723 10.1244 8.53458 8.89917 8.53458C7.67391 8.53458 6.55958 9.64723 6.55958 10.8712V14.8773H2.8834V7.53287C2.8834 7.31059 2.6607 7.08789 2.43758 7.08789C2.21488 7.08789 1.99219 7.31059 1.99219 7.53287V15.3222C1.99219 15.6559 2.21488 15.8786 2.43758 15.8786H7.0054C7.33945 15.8786 7.4508 15.6559 7.56257 15.4336V10.8712C7.56257 10.0922 8.11931 9.53589 8.89917 9.53589C9.67903 9.53589 10.2358 10.0922 10.2358 10.8712V15.4336C10.3475 15.6559 10.4589 15.8786 10.7929 15.8786H15.3603C15.5835 15.8786 15.8062 15.6559 15.8062 15.3222V7.53287C15.8062 7.31059 15.5835 7.08789 15.3603 7.08789Z",
    fill: "#36505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.5ca862a5f1bbf5895d778896809882c2.svg";
export { ForwardRef as ReactComponent };